import * as authorization from './authorization'

import * as RestAPIService from './rest'

export const api = {
  authorization
}

export const restApi = RestAPIService
